module.exports = __webpack_public_path__ + "img/folder_icon.dedfce6d.svg";